// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"07f8df7c","453":"c02cac72","667":"7f360aa0","977":"5505bdc6"}[chunkId] + ".chunk.js";
};